import { FC, memo } from "react";

import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import classes from "./rentableGroupCalculatorInstruction.scss";

interface IRentableGroupCalculatorInstructionsProps {
  paragraph: string;
}

const RentableGroupCalculatorInstructions: FC<IRentableGroupCalculatorInstructionsProps> =
  memo(({ paragraph }) => {
    return (
      <section className={classes.root}>
        <RentableGroupCalculatorHtmlContent
          as="p"
          className={classes.paragraph}
          html={paragraph}
        />
      </section>
    );
  });
export default RentableGroupCalculatorInstructions;
